<template>
  <div class="store-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">商品管理</h2>
        <p class="page-desc">管理商品信息、媒体资源、规格与库存</p>
      </div>
      <el-button icon="el-icon-plus" type="primary" @click="onShowSave('新增')">新增商品</el-button>
    </div>

    <div class="manage-card">
      <el-tabs v-model="stateValue" class="manage-tabs" @tab-click="tabClick">
        <el-tab-pane v-for="(state,j) in status" :key="j" :label="state" :name="state"/>
      </el-tabs>

      <div class="filter-bar">
        <el-form :model="params" class="filter-form" inline @submit.native.prevent="search">
          <el-form-item label="商品 ID">
            <el-input v-model="params.id" clearable placeholder="商品 ID"/>
          </el-form-item>
        </el-form>
        <div class="filter-actions">
          <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
      </div>

      <div class="store-manage-page__table">
        <el-table v-loading="loadTable" :data="records" row-key="id" size="small" stripe>
          <el-table-column fixed label="ID" prop="id" width="72"/>
          <el-table-column fixed label="商品信息" min-width="220">
            <template slot-scope="{ row }">
              <div class="item-info">
                <el-image :preview-src-list="[row.coverImg]" :src="row.coverImg" class="item-info__cover" fit="cover"/>
                <div class="item-info__body">
                  <div :title="row.name" class="item-info__title">{{ row.name }}</div>
                  <div :title="row.desc" class="item-info__meta">{{ row.desc || '暂无简述' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="原价" prop="originPrice" width="80"/>
          <el-table-column align="center" label="现价" prop="price" width="80"/>
          <el-table-column align="center" label="浏览量" prop="lookNum" width="80"/>
          <el-table-column align="center" label="浏览量显示" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.isShowLookNum === '是' ? 'success' : 'info'" effect="plain" size="mini">
                {{ row.isShowLookNum === '是' ? '已开启' : '已关闭' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.state === '上' ? 'success' : 'info'" effect="light" size="mini">
                {{ row.state === '上' ? '上架' : '下架' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="160" prop="createdTime" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="{ row, $index }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="onShowSave('修改', row)">编辑</el-button>
                <el-button size="mini" type="text" @click="onShowSpecificationPanel(row)">规格</el-button>
                <el-dropdown trigger="click" @command="cmd => handleRowCommand(cmd, row, $index)">
                  <el-button size="mini" type="text">
                    更多<i class="el-icon-arrow-down el-icon--right"/>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="moveUp" :disabled="$index === 0">上移</el-dropdown-item>
                    <el-dropdown-item command="moveDown" :disabled="$index === records.length - 1">下移</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='下'" command="shelfUp" divided>上架</el-dropdown-item>
                    <el-dropdown-item v-if="row.state==='上'" command="shelfDown">下架</el-dropdown-item>
                    <el-dropdown-item v-if="row.isShowLookNum==='是'" command="lookOff" divided>关闭浏览量</el-dropdown-item>
                    <el-dropdown-item v-if="row.isShowLookNum==='否'" command="lookOn">开启浏览量</el-dropdown-item>
                    <el-dropdown-item command="video" divided>视频管理</el-dropdown-item>
                    <el-dropdown-item command="image">图片管理</el-dropdown-item>
                    <el-dropdown-item command="warehouse">仓库管理</el-dropdown-item>
                    <el-dropdown-item v-if="row.isOpenLongpress==='是'" command="longpressOff" divided>关闭长按菜单</el-dropdown-item>
                    <el-dropdown-item v-if="row.isOpenLongpress==='否'" command="longpressOn">开启长按菜单</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>


    <!--  保存  -->
    <el-dialog
        :title="title"
        :visible.sync="showSave"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="save" ref="ruleForm">
        <el-form-item label="商品名" prop="name"
                      :rules="[
                        {required: true, message: '请输入商品名', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="save.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="标题颜色" prop="titleColor"
                      :rules="[
                        {required: true, message: '请选择标题颜色', trigger: 'blur'}
                        ]">
          <div class="block">
            <el-color-picker v-model="save.titleColor"></el-color-picker>
          </div>
        </el-form-item>
        <el-form-item label="封面" prop="coverImg"
                      :rules="[
                        {required: true, message: '请上传封面', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
            >
              <img v-if="save.coverImg" :src="save.coverImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="购买按钮" prop="buybtn"
                      :rules="[
                        {required: true, message: '请输入购买按钮', trigger: 'blur'},
                        ]">
          <el-input v-model="save.buybtn" maxlength="20" placeholder="立即购买"></el-input>
        </el-form-item>
        <el-form-item label="是否显示客服二维码" prop="isShowServerQRCode">
          <el-select v-model="save.isShowServerQRCode" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否使用默认客服二维码" prop="isDefaultServerQRCode">
          <el-select v-model="save.isDefaultServerQRCode" placeholder="请选择">
            <el-option
                v-for="item in displays"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单独上传客服二维码" prop="serverQRCode" v-if="save.isDefaultServerQRCode=='否'">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :on-success="ServerQRCodeHandleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
              <img v-if="save.serverQRCode" :src="save.serverQRCode" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="简述" prop="desc"
                      :rules="[
                        {max: 50, message: '长度最高为50', trigger: 'blur'}
                        ]">
          <el-input v-model="save.desc" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="详述" prop="descDetail">
          <el-input v-model="save.descDetail" clearable type="textarea" autosize></el-input>
        </el-form-item>
        <el-form-item label="原价(佣金)" prop="originPrice">
          <el-input v-model.number="save.originPrice" type="number"></el-input>
        </el-form-item>
        <el-form-item label="现价(佣金)" prop="price"
                      :rules="[
                        {required: true, message: '请输入现价', trigger: 'blur'},
                        ]">
          <el-input v-model.number="save.price" type="number"></el-input>
        </el-form-item>
        <el-form-item label="市场价(元)" prop="marketplacePrice">
          <el-input v-model.number="save.marketplacePrice" type="number"></el-input>
        </el-form-item>
        <el-form-item label="市场价单位" prop="marketplacePriceUnit">
          <el-input v-model="save.marketplacePriceUnit" maxlength="10" placeholder="斤/只/条/张/个"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSave = false">取 消</el-button>
        <el-button type="primary" @click="doSave('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!--  上下架  -->
    <el-dialog
        title="提示"
        :visible.sync="showChangeState"
        width="30%"
        center>
      <div style="align-content: center">您确认要{{changeState.state=='上'?'上架':'下架'}}ID为 {{changeState.id}} 吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChangeState = false">取 消</el-button>
        <el-button type="primary" @click="doChangeState">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除 -->
    <el-dialog
        title="提示"
        :visible.sync="showDel"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="doDel">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除资源 -->
    <el-dialog
        title="提示"
        :visible.sync="showDelResource"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelResource = false">取 消</el-button>
        <el-button type="primary" @click="doDelResource">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 资源 -->
    <el-dialog
        :title="type==='0'?'图片':'视频'"
        :visible.sync="showResource"
        width="30%"
        center>

      <el-button type="primary" @click="uploadResource">上传</el-button>

      <div v-for="(e,i) in resources" :key="i">
        <span v-if="e.type==='0'">
          <img :src="fileBaseUrl+e.url" width="100px" height="100px">
        </span>
        <span v-else>
          <video :src="fileBaseUrl+e.url" width="100px" height="150px"></video>
        </span>
        <el-button  type="info" size="mini" icon="el-icon-top" circle @click="moveResource(e, true)"></el-button>
        <el-button type="info" size="mini" icon="el-icon-bottom" circle @click="moveResource(e, false)"></el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="onShowDelResource(e)"></el-button>
      </div>

      <input
          type="file"
          accept="video/*"
          name="file"
          ref="uploadFileVideo"
          id="uploadFileVideo"
          multiple
          @change="changevideoMultiple"
          style="opacity: 0; width: 0; height: 0; cursor: pointer"
      />
      <input
          type="file"
          accept="image/*"
          name="file"
          ref="uploadFileImage"
          id="uploadFileImage"
          multiple
          @change="changeimageMultiple"
          style="opacity: 0; width: 0; height: 0; cursor: pointer"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="showResource = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 规格 -->
    <el-dialog
        title="规格"
        :visible.sync="showSpecificationPanel"
        width="30%"
        center
    >

      <!-- 规格 -->
      <div>
        <el-button icon="el-icon-circle-plus-outline" @click="showSpecification = true" v-show="specifications.length<2">新增规格</el-button>
        <div>
          <el-radio-group v-model="selectSpecificationId" @change="specificationChange">
            <span v-for="(e,i) in specifications" :key="i">
              <el-radio-button :label="e.id">{{e.name}}</el-radio-button>
            </span>
            <el-button v-show="selectSpecificationId" @click="editSpecification" size="mini" type="primary" icon="el-icon-edit" circle></el-button>
            <el-button v-show="selectSpecificationId" @click="removeSpecification" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
          </el-radio-group>
        </div>
      </div>
      <!-- 规格值 -->
      <div v-show="selectSpecificationId">
        <el-button icon="el-icon-circle-plus-outline" @click="showSpecificationValue = true">新增规格值</el-button>
        <div>
          <el-radio-group v-model="selectSpecificationValueId">
            <span v-for="(e,i) in specificationValues" :key="i">
              <el-radio-button :label="e.id">{{e.name}}</el-radio-button>
            </span>
            <el-button v-show="selectSpecificationValueId" @click="editSpecificationValue" size="mini" type="primary" icon="el-icon-edit" circle></el-button>
            <el-button v-show="selectSpecificationValueId" @click="removeSpecificationValue" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
          </el-radio-group>
        </div>
      </div>
      <!-- 规格值图片 -->
      <div v-show="specifications.length>0 && selectSpecificationId==specifications[0].id && selectSpecificationValueId">
        <el-form label-position="left">
          <el-form-item label="封面" prop="coverImg">
            <div class="avatar-uploader">
              <el-upload
                  :action="fileBaseUrl"
                  :show-file-list="false"
                  :data="uploadData"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                <img v-if="specificationValueCoverImg" :src="fileBaseUrl+specificationValueCoverImg" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpecificationPanel = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 新增规格 -->
    <el-dialog
        title="新增规格"
        :visible.sync="showSpecification"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="specification" ref="specificationRuleForm">
        <el-form-item label="规格名" prop="name"
                      :rules="[
                        {required: true, message: '请输入规格名', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="specification.name" maxlength="20" placeholder="例如颜色或尺码" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpecification = false">关 闭</el-button>
        <el-button type="primary" @click="doSaveSpecification('specificationRuleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 新增规格值 -->
    <el-dialog
        title="新增规格值"
        :visible.sync="showSpecificationValue"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="specificationValue" ref="specificationValueRuleForm">
        <el-form-item label="规格值" prop="name"
                      :rules="[
                        {required: true, message: '请输入规格值', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="specificationValue.name" maxlength="20" placeholder="例如粉色或40码" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpecificationValue = false">关 闭</el-button>
        <el-button type="primary" @click="doSaveSpecificationValue('specificationValueRuleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 仓库 -->
    <el-dialog
        title="仓库"
        :visible.sync="showRepository"
        width="30%"
        center>

      <div v-for="(e,i) in specifications" :key="i">
        <el-radio-group v-model="selectSpecificationValueArr[i]" @change="specificationValueArrChange">
          <span v-for="(r,j) in specificationValueArr" :key="j">
            <el-radio-button v-if="r.specificationId===e.id" :label="r.id">{{r.name}}</el-radio-button>
          </span>
          <el-button v-show="selectSpecificationId" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
        </el-radio-group>
      </div>
      <!-- 保存仓库 -->
      <div v-show="showRepositoryConfig">
        <el-form :model="repository" label-width="80px" ref="repositoryRuleForm">
          <el-form-item label="库存数量" prop="num">
            <el-input v-model.number="repository.num" disabled></el-input>
          </el-form-item>
          <el-form-item label="加减库存" prop="addNum"
                        :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        ]">
            <el-input v-model.number="repository.addNum" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="原价(佣金)" prop="originPrice"
                        :rules="[
                        { validator: notLtNum0, trigger: 'blur' }
                        ]">
            <el-input v-model="repository.originPrice" @change="originPriceChange"></el-input>
          </el-form-item>
          <el-form-item label="现价(佣金)" prop="price"
                        :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        { validator: notLtNum0, trigger: 'blur' }
                        ]">
            <el-input v-model="repository.price" @change="priceChange"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="doSaveRepository('repositoryRuleForm')">修 改</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showRepository = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 修改规格 -->
    <el-dialog
        title="修改规格"
        :visible.sync="showEditSpecification"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="editSpecificationParams" ref="editSpecificationRuleForm">
        <el-form-item label="规格名" prop="name"
                      :rules="[
                        {required: true, message: '请输入规格名', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="editSpecificationParams.name" maxlength="20" placeholder="例如颜色或尺码" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditSpecification = false">关 闭</el-button>
        <el-button type="primary" @click="doEditSpecification('editSpecificationRuleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 修改规格值 -->
    <el-dialog
        title="修改规格值"
        :visible.sync="showEditSpecificationValue"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="editSpecificationValueParams" ref="editSpecificationValueRuleForm">
        <el-form-item label="规格值" prop="name"
                      :rules="[
                        {required: true, message: '请输入规格值', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="editSpecificationValueParams.name" maxlength="20" placeholder="例如粉色或40码" clearable></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditSpecificationValue = false">关 闭</el-button>
        <el-button type="primary" @click="doEditSpecificationValue('editSpecificationValueRuleForm')">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import {Message} from "element-ui";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import swapOrder from "@/api/store/StoreProduct/swapOrder";
import changeState from "@/api/store/StoreProduct/changeState";
import remove from "@/api/store/StoreProduct/remove";
import save from "@/api/store/StoreProduct/save";
import saveValueCoverImg from "@/api/store/StoreProductSpecificationValueCoverImg/save";
import saveRepository from "@/api/store/StoreProductRepository/save";
import saveSpecification from "@/api/store/StoreProductSpecification/save";
import saveSpecificationValue from "@/api/store/StoreProductSpecificationValue/save";
import saveResource from "@/api/store/StoreProductResource/save";
import StoreProductPage from "@/api/store/StoreProduct/page";
import resourceList from "@/api/store/StoreProductResource/list";
import Axios from "axios";
import {resetSourceDefaulter} from "echarts/lib/data/helper/sourceHelper";
import swapOrderResource from "@/api/store/StoreProductResource/swapOrderResource";
import removeResource from "@/api/store/StoreProductResource/removeResource";
import specificationList from "@/api/store/StoreProductSpecification/list";
import specificationValueList from "@/api/store/StoreProductSpecificationValue/list";
import removeSpecification from "@/api/store/StoreProductSpecification/remove";
import removeSpecificationValue from "@/api/store/StoreProductSpecificationValue/remove";
import listByProductId from "@/api/store/StoreProductSpecificationValue/listByProductId";
import listRepositoryByProductId from "@/api/store/SpecificationValueRepository/listByProductId";
import {notLtNum0} from "@/utils/check";
import listValueCoverImgs from "@/api/store/StoreProductSpecificationValueCoverImg/list";
import Page from "@/components/Page.vue";
import adminOpenCloseProductLookNum from "@/api/user/admin-controler/adminOpenCloseProductLookNum";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";
import changeIsOpenLongpress from "@/api/store/StoreProduct/changeIsOpenLongpress";

export default {
  name: "StoreProductManage",
  components: {Page},
  data() {
    return {
      current:1,
      size:10,
      total: 0,
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData:{},
      params: {
        id: this.$route.params.productId,
      },
      loadTable: false,
      records: [],

      typeId: localStorage.getItem("storeTypeId"),

      state: '上',
      status:['上架','下架'],
      stateValue:'上架',


      showSave:false,
      title:undefined,
      save:{
        isShowServerQRCode:'是',
        isDefaultServerQRCode:'是',
        serverQRCode:'',
        buybtn:'立即购买',
      },
      displays: [
        {
          value: '是',
          label: '是',
        },
        {
          value: '否',
          label: '否',
        },
      ],

      showChangeState:false,
      changeState:{},
      delId: undefined,
      showDel: false,
      delIdResource: undefined,
      showDelResource: false,

      showResource:false,
      resources:[],
      type:'0',
      productId:undefined,

      showSpecificationPanel:false,

      showSpecification:false,
      specification:{},
      specifications:[],
      selectSpecificationId:undefined,

      showSpecificationValue:false,
      specificationValue:{},
      specificationValues:[],
      selectSpecificationValueId:undefined,
      specificationValueCoverImg:undefined,
      valueCoverImgMap:new Map(),

      showRepository:false,
      repositoryProductId:undefined,
      specificationValueArr:[],
      selectSpecificationValueArr:[],
      showRepositoryConfig:false,
      repositoryMap:new Map(),
      repository:{},

      showEditSpecification:false,
      editSpecificationParams:{
        id:undefined,
        name:undefined,
        productId:undefined,
      },

      showEditSpecificationValue:false,
      editSpecificationValueParams:{
        id:undefined,
        name:undefined,
        specificationId:undefined,
      },

    }
  },
  watch:{
    'selectSpecificationValueId':{
      handler(n){
        this.specificationValueCoverImg=this.valueCoverImgMap.get(n)
      }
    }
  },
  methods: {
    // 处理行命令
    handleRowCommand(command, row, $index) {
      switch (command) {
        case 'moveUp':
          this.move(row, true)
          break
        case 'moveDown':
          this.move(row, false)
          break
        case 'shelfUp':
          this.onChangeState(row.id, '上')
          break
        case 'shelfDown':
          this.onChangeState(row.id, '下')
          break
        case 'lookOff':
          this.onOpenCloseLookNum(row.id, '否')
          break
        case 'lookOn':
          this.onOpenCloseLookNum(row.id, '是')
          break
        case 'video':
          this.onShowResource(row, '1')
          break
        case 'image':
          this.onShowResource(row, '0')
          break
        case 'warehouse':
          this.onShowRepository(row)
          break
        case 'longpressOff':
          this.doChangeIsOpenLongpress(row, '否')
          break
        case 'longpressOn':
          this.doChangeIsOpenLongpress(row, '是')
          break
      }
    },
    doEditSpecificationValue(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveSpecificationValue(this.editSpecificationValueParams).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showEditSpecificationValue=false
              this.getSpecificationValues(this.selectSpecificationId)
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    doEditSpecification(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveSpecification(this.editSpecificationParams).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showEditSpecification=false
              this.getSpecifications(this.specification.productId)
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onOpenCloseLookNum(id, isShowLookNum){
      adminOpenCloseProductLookNum(id, isShowLookNum).then(res=>{
        if(res.code==1){
          Message({
            message:'成功',
            type:"success",
            duration:3000
          })
          this.fetchData()
        }else{
          Message({
            message:'失败',
            type:"error",
            duration:3000
          })
        }
      })
    },
    async beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isGIF = file.type === 'image/gif';

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error('上传头像图片只能是 JPG或PNG或GIF 格式!');
      }
      if(isJPG || isPNG || isGIF) {
        await getAliyunOssSign("/common/sign").then(response => {
          //设置相关的参数
          let resultObj = response.data;
          this.uploadData.policy = resultObj.policy;
          this.uploadData.signature = resultObj.signature;
          this.uploadData.ossaccessKeyId = resultObj.accessid;
          //上传的文件名，使用UUID处理一下
          this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
          this.uploadData.dir = resultObj.dir;
          this.uploadData.host = resultObj.host;
        });
        return true
      }
      return false
    },
    handleAvatarSuccess(response, file) {
      let path = this.uploadData.key.replace("${filename}",file.name)
      let params = {
        coverImg:path,
        valueId:this.selectSpecificationValueId
      }
      saveValueCoverImg(params).then(res=>{
        if(res.code===1){
          Message({message:"成功",type:"success",duration:3000})
          let newPath = '/'+path.replace('temp','StoreProductSpecificationValueCoverImg')
          this.specificationValueCoverImg=newPath
          this.valueCoverImgMap.set(this.selectSpecificationValueId,newPath)
        }else{
          Message({message:"失败",type:"error",duration:3000})
        }
      })
    },
    doSaveRepository(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.repository))
          params.specificationValueIds=this.selectSpecificationValueArr
          saveRepository(params).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.getRepositoryMap(this.repositoryProductId)
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    notLtNum0,
    originPriceChange(originPrice){
      if(isNaN(originPrice) || originPrice===''){
        return this.repository.originPrice=undefined
      }
      if(typeof originPrice === 'string'){
        this.repository.originPrice=parseFloat(originPrice)
      }
      let s = ''+originPrice
      if (s.indexOf('.')!==-1) {
        let arr = s.split('.')
        if(arr[1].length>2){
          arr[1]=arr[1].substring(0,2)
          // this.$set(this.repository,'price',parseFloat(arr[0]+'.'+arr[1]))
          this.repository.originPrice=parseFloat(arr[0]+'.'+arr[1])
        }
      }
    },
    priceChange(price){
      if(typeof price === 'string'){
        this.repository.price=parseFloat(price)
      }
      let s = ''+price
      if (s.indexOf('.')!==-1) {
        let arr = s.split('.')
        if(arr[1].length>2){
          arr[1]=arr[1].substring(0,2)
          // this.$set(this.repository,'price',parseFloat(arr[0]+'.'+arr[1]))
          this.repository.price=parseFloat(arr[0]+'.'+arr[1])
        }
      }
    },
    specificationValueArrChange(){
      let arr = this.selectSpecificationValueArr
      let flag = true
      for(let i=0;i<arr.length;i++){
        if(!arr[i]){
          flag=false
          break
        }
      }
      this.showRepositoryConfig=flag
      if(flag){
        let keys = []
        for(let i=0;i<arr.length;i++){
          keys.push(arr[i])
        }
        keys.sort((a,b)=>a-b)
        let key = ''+keys[0]
        for(let i=1;i<keys.length;i++){
          key+=','+keys[i]
        }
        let repository = this.repositoryMap.get(key)
        if(!repository){
          repository={num:0,price:0.00}
        }
        repository.addNum=0
        this.repository=repository
      }
    },
    onShowRepository(row){
      this.repositoryProductId=row.id
      this.getSpecifications(row.id)
      this.getSpecificationValuesByProductId(row.id)
      this.getRepositoryMap(row.id)
      this.showRepository=true
      this.showRepositoryConfig=false
    },
    getRepositoryMap(productId){
      this.repositoryMap.clear()
      listRepositoryByProductId(productId).then(res=>{
        let data = res.data
        if(data && data.length>0){
          let map = new Map()
          let map2 = new Map()
          for(let i=0;i<data.length;i++){
            let e = data[i]
            if(!map2.has(e.repositoryId)){
              map2.set(e.repositoryId,{id:e.repositoryId,num:e.num,originPrice:e.originPrice,price:e.price})
            }
            let specificationValueId = map.get(e.repositoryId)
            if(specificationValueId){
              map.set(e.repositoryId,specificationValueId+','+e.specificationValueId)
            }else{
              map.set(e.repositoryId,e.specificationValueId)
            }
          }
          map.forEach((v,k)=>{
            this.repositoryMap.set(''+v,map2.get(k))
          })
          if(this.showRepository){
            this.specificationValueArrChange()
          }
        }
      })
    },
    getSpecificationValuesByProductId(productId){
      listByProductId(productId).then(res=>{
        let data = res.data
        let selectSpecificationValueArr = []
        let specificationIds = new Set()
        for(let i=0;i<data.length;i++){
          specificationIds.add(data[i].specificationId)
        }
        for(let i=0;i<specificationIds.size;i++){
          selectSpecificationValueArr.push(undefined)
        }
        this.selectSpecificationValueArr=selectSpecificationValueArr
        this.specificationValueArr=data
      })
    },
    specificationChange(specificationId){
      this.getSpecificationValues(specificationId)
    },
    editSpecificationValue(){
      this.editSpecificationValueParams={
        id:this.selectSpecificationValueId,
        name:this.specificationValues.find(e=>e.id==this.selectSpecificationValueId).name,
        specificationId:this.selectSpecificationId,
      }
      this.showEditSpecificationValue=true
    },
    removeSpecificationValue(){
      this.$confirm('将删除该规格值, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSpecificationValue(this.selectSpecificationValueId).then(res=>{
          if(res.code===1){
            Message({message:"成功",type:"success",duration:3000})
            this.getSpecificationValues(this.selectSpecificationId)
          }else{
            if(res.data && res.data.illError){
              Message({message:res.data.illError,type:"error",duration:3000})
            }else{
              Message({message:"失败",type:"error",duration:3000})
            }
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    editSpecification(){
      this.editSpecificationParams = {
        id: this.selectSpecificationId,
        name: this.specifications.find(e=>e.id==this.selectSpecificationId).name,
        productId:this.specification.productId
      }
      this.showEditSpecification = true
    },
    removeSpecification(){
      this.$confirm('您将删除该规格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeSpecification(this.selectSpecificationId).then(res=>{
          if(res.code===1){
            Message({message:"成功",type:"success",duration:3000})
            this.getSpecifications(this.specification.productId)
          }else{
            if(res.data && res.data.illError){
              Message({message:res.data.illError,type:"error",duration:3000})
            }else{
              Message({message:"失败",type:"error",duration:3000})
            }
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    doSaveSpecificationValue(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.specificationValue.specificationId=this.selectSpecificationId
          saveSpecificationValue(this.specificationValue).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSpecificationValue=false
              this.getSpecificationValues(this.selectSpecificationId)
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    doSaveSpecification(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveSpecification(this.specification).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSpecification=false
              this.getSpecifications(this.specification.productId)
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowSpecificationPanel(row){
      this.specificationValueCoverImg=undefined
      this.getSpecifications(row.id)
      this.selectSpecificationId=undefined
      this.specification.productId=row.id
      this.showSpecificationPanel=true
    },
    getSpecifications(productId){
      specificationList(productId).then(res=>{
        let data = res.data
        this.specifications=data
        this.selectSpecificationId=undefined
      })
    },
    getSpecificationValues(specificationId){
      specificationValueList(specificationId).then(res=>{
        let data = res.data
        this.specificationValues=data
        this.selectSpecificationValueId=undefined
        this.getSpecificationValueCoverImgs()
      })
    },
    getSpecificationValueCoverImgs(){
      let valueIds = []
      let specificationValues = this.specificationValues
      for(let i=0;i<specificationValues.length;i++){
        let id = specificationValues[i].id
        if(!this.valueCoverImgMap.has(id)) valueIds.push(id)
      }
      if(valueIds.length>0){
        listValueCoverImgs({ids:valueIds}).then(res=>{
          let arr = res.data
          for(let i=0;i<arr.length;i++){
            let e = arr[i]
            this.valueCoverImgMap.set(e.valueId,e.coverImg)
          }
        })
      }
    },
    resetSourceDefaulter,
    doChangeIsOpenLongpress(row, isOpenLongpress){
      const params = {
        id: row.id,
        isOpenLongpress: isOpenLongpress,
      }
      changeIsOpenLongpress(params).then(res=>{
        if(res.code!=1){
          Message({
            message: '失败',
            type: 'error',
            duration: 3 * 1000
          });
        }else {
          Message({
            message: '成功',
            type: 'success',
            duration: 3000
          });
          this.fetchData()
        }
      })
    },
    uploadFile(file, type){
      getAliyunOssSign("/common/sign").then(response=>{
        //设置相关的参数
        let resultObj = response.data;
        //上传的文件名，使用UUID处理一下
        let pre = resultObj.dir + '/'+this.getUUID()+'_'
        // file = file.target.files[0];
        let data = new FormData();
        data.append("key", pre+'${filename}')
        data.append("OSSAccessKeyId", resultObj.accessid)
        data.append("policy", resultObj.policy)
        data.append("signature", resultObj.signature)
        data.append("file", file)
        data.append("success_action_status", 200)

        let config = {
          'Content-Type': 'multipart/form-data'
        }
        Axios.post(resultObj.host, data, config).then((res)=>{
          if(res.status==200){
            let url = pre+file.name
            let params = {
              url:url,
              type:type,
              productId:this.productId
            }
            saveResource(params).then(res=>{
              if(res.code===1){
                resourceList(this.productId,type).then(res=>{
                  this.resources=res.data
                })
                Message({
                  message:"成功",
                  type:"success",
                  duration:3000
                })
              }else{
                Message({
                  message:"失败",
                  type:"error",
                  duration:3000
                })
              }
            })
          }
        }).catch(err=>{
          console.error(err)
          Message({
            message: '上传失败',
            type: 'error',
            duration: 3 * 1000
          });
        })
      });

    },
    changeimageMultiple(e){
      const files = e.target.files
      for (let file of files){
        this.changeimage(file)
      }
    },
    changeimage(file) {
      this.uploadFile(file, '0')
    },
    changevideoMultiple(e){
      const files = e.target.files
      for (let file of files){
        this.changevideo(file)
      }
    },
    changevideo(file) {
      this.uploadFile(file, '1')
    },
    uploadResource(){
      if(this.type==='0'){
        document.querySelector("#uploadFileImage").click();
      }else{
        document.querySelector("#uploadFileVideo").click();
      }
    },
    onShowResource(row,type){
      resourceList(row.id,type).then(res=>{
        this.productId=row.id
        this.type=type
        this.resources=res.data
        this.showResource=true
      })
    },
    doSave(formName){
      if (this.save.isDefaultServerQRCode=='否' && !this.save.serverQRCode){
        return Message({
          message: '不使用默认客服二维码时必须单独上传客服二维码！',
          type: 'error',
          duration: 3 * 1000
        });
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.save))
          params.typeId=this.typeId
          params.coverImg=params.coverImg.split('?')[0].substring(this.fileBaseUrl.length+1)
          if (params.serverQRCode){
            params.serverQRCode = params.serverQRCode.split('?')[0].substring(this.fileBaseUrl.length+1)
          }
          save(params).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSave=false
              this.fetchData()
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    handler ({BMap, map}) {
      let _this = this;  // 设置一个临时变量指向vue实例，因为在百度地图回调里使用this，指向的不是vue实例；
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        _this.center = {lng: r.longitude, lat: r.latitude};   // 设置center属性值
        _this.autoLocationPoint = {lng: r.longitude, lat: r.latitude};  // 自定义覆盖物
        _this.initLocation = true;
      },{enableHighAccuracy: true})
      window.map = map;
      window.BMap = BMap;
    },
    onShowMap(){
      if(!this.save.areaDetailId){
          return Message({
            message:'请选择地区',
            type:"error",
            duration:3000
          })
      }
      this.mapVisible = true
    },
    onShowSave(title,row){
      this.title=title
      this.save={
        titleColor: '#000000',
        coverImg: undefined,
        isShowServerQRCode:'是',
        isDefaultServerQRCode:'是',
        serverQRCode:'',
        buybtn: '立即购买',
      }
      if(row){
        this.save=JSON.parse(JSON.stringify(row))
      }
      this.showSave=true
    },
    onShowDel(row){
      this.delId = row.id
      this.showDel = true
    },
    onShowDelResource(row){
      this.delIdResource = row.id
      this.showDelResource = true
    },
    doDel(){
      let that = this
      remove(this.delId).then(res=>{
        if(res.code!=1){
          Message({
            message: '删除失败',
            type: 'error',
            duration: 3 * 1000
          });
        }else {
          Message({
            message: '删除成功',
            type: 'success',
            duration: 3 * 1000
          });
          that.showDel = false
          that.fetchData()
        }
      })
    },
    doDelResource(){
      let that = this
      removeResource(this.delIdResource).then(res=>{
        if(res.code!=1){
          Message({
            message: '删除失败',
            type: 'error',
            duration: 3 * 1000
          });
        }else {
          Message({
            message: '删除成功',
            type: 'success',
            duration: 3 * 1000
          });
          that.showDelResource = false
          resourceList(this.productId,this.type).then(res=>{
            this.resources=res.data
          })
        }
      })
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    async beforeUpload(){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
      });
      return true
    },
    ServerQRCodeHandleAvatarSuccess(response, file) {
      adminGetFileSignUrl(this.uploadData.key.replace("${filename}", file.name)).then(res => {
        this.save.serverQRCode = res.data
      })
    },
    //文件上传成功回调
    handleSuccess(response, file){
      //上传的完整的文件地址
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}",file.name) ;
      let name = urlPath.substring(this.fileBaseUrl.length+1)
      adminGetFileSignUrl(name).then(res=>{
        this.save.coverImg=res.data
        this.tempCoverImg=res.data
      })
    },
    tabClick(){
      if(this.stateValue==='上架'){
        this.state='上'
      }
      if(this.stateValue==='下架'){
        this.state='下'
      }

      this.reset()
    },
    areaChange(e){
      this.params.areaDetailId=undefined
      this.params.provinceId=undefined
      this.params.cityId=undefined
      this.params.areaId=undefined
      if(e.length===1){
        this.params.provinceId=e[0]
      }
      if(e.length===2){
        this.params.cityId=e[1]
      }
      if(e.length===3){
        this.params.areaId=e[2]
      }
    },
    isUp(row){
      return row.id!=this.records[0].id
    },
    isUpResource(row){
      return row.id!=this.resources[0].id
    },
    isDown(row){
      return row.id!=this.records[this.records.length-1].id
    },
    isDownResource(row){
      return row.id!=this.resources[this.resources.length-1].id
    },
    move(row,isUp){
      swapOrder(row.id,isUp).then(res=>{
        if(res.code===1){
          Message({
            message: '成功',
            type: 'success',
            duration: 3 * 1000
          });
          this.fetchData()
        }
      })
    },
    // move(row, type) {
    //   //查询需要交换位置的两个id和order
    //   let swap = undefined
    //   let records = this.records
    //   let j = undefined
    //   for (let i = 0; i < records.length; i++) {
    //     if (records[i].id == row.id) {
    //       j = i
    //     }
    //   }
    //   if (type === '上') {
    //     swap = records[j - 1]
    //   } else {
    //     swap = records[j + 1]
    //   }
    //
    //   let a = {
    //     id: row.id,
    //     order: row.order,
    //   }
    //   let b = {
    //     id: swap.id,
    //     order: swap.order,
    //   }
    //
    //   swapOrder([a,b]).then(res=>{
    //     if(res.code==1){
    //       Message({
    //         message: '成功',
    //         type: 'success',
    //         duration: 3 * 1000
    //       });
    //       this.fetchData()
    //     }
    //   })
    // },
    moveResource(row,isUp){
      swapOrderResource(row.id,isUp).then(res=>{
          if(res.code===1){
            Message({
              message: '成功',
              type: 'success',
              duration: 3 * 1000
            });
            resourceList(this.productId,this.type).then(res=>{
              this.resources=res.data
            })
          }
      })
    },
    // moveResource(row, type) {
    //   //查询需要交换位置的两个id和order
    //   let swap = undefined
    //   let records = this.resources
    //   let j = undefined
    //   for (let i = 0; i < records.length; i++) {
    //     if (records[i].id == row.id) {
    //       j = i
    //     }
    //   }
    //   if (type === '上') {
    //     swap = records[j - 1]
    //   } else {
    //     swap = records[j + 1]
    //   }
    //
    //   let a = {
    //     id: row.id,
    //     order: row.order,
    //   }
    //   let b = {
    //     id: swap.id,
    //     order: swap.order,
    //   }
    //
    //   swapOrderResource([a,b]).then(res=>{
    //     if(res.code==1){
    //       Message({
    //         message: '成功',
    //         type: 'success',
    //         duration: 3 * 1000
    //       });
    //       resourceList(this.productId,this.type).then(res=>{
    //         this.resources=res.data
    //       })
    //     }
    //   })
    // },
    onChangeState(id,state){
      this.changeState.id=id
      this.changeState.state=state
      this.showChangeState = true
    },
    doChangeState(){
      changeState(this.changeState.id, this.changeState.state).then(res=>{
        if(res.code===1){
          Message({
            message:"成功",
            type:"success",
            duration:3000
          })
          this.showChangeState = false
          this.fetchData()
        }else{
          if(res.data && res.data.illError){
            Message({
              message:res.data.illError,
              type:"error",
              duration:3000
            })
          }else{
            Message({
              message:res.msg,
              type:"error",
              duration:3000
            })
          }
        }
      })
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.current=1
      this.params = {}
      // this.$refs.cascader.panel.checkedValue = []
      this.fetchData()
    },
    fetchData(){
      this.params.typeId=this.typeId
      this.params.state=this.state
      StoreProductPage(this.current,this.size,this.params).then(res=>{
        let data = res.data.data
        for(let i=0;i<data.length;i++){
          let e = data[i]
          e.coverImg=this.fileBaseUrl+e.coverImg
          e.serverQRCode=e.serverQRCode ? this.fileBaseUrl+e.serverQRCode : ''
        }
        this.records=data
        this.total=res.data.total
      })
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.store-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;

  &__info {
    flex: 1;
  }
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.manage-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.manage-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

.filter-bar {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
}

.filter-form {
  display: inline-block;
}

.filter-actions {
  display: inline-block;
  margin-left: 16px;
}

.store-manage-page__table {
  padding: 0 20px;
}

.item-info {
  display: flex;
  align-items: center;
  gap: 12px;

  &__cover {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    border: 1px solid #eef0f3;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__meta {
    font-size: 12px;
    color: #9ca3af;
    margin-top: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-footer {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

@media (max-width: 768px) {
  .store-manage-page {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filter-bar {
    padding: 12px;
  }

  .store-manage-page__table {
    padding: 0 12px;
  }
}
</style>
